'use strict';

/* ═══════════════════════════════════════════
   NAVAK — custom cursor + glitter
═══════════════════════════════════════════ */

/* CURSOR */
(function () {
  var dot = document.getElementById('NC');
  var ring = document.getElementById('NR');
  if (!dot || !ring) return;
  document.addEventListener('mousemove', function (e) {
    dot.style.left = e.clientX + 'px';
    dot.style.top = e.clientY + 'px';
    ring.style.left = e.clientX + 'px';
    ring.style.top = e.clientY + 'px';
  }, { passive: true });
  document.addEventListener('mouseover', function (e) {
    if (e.target.closest('a, button, [role="button"], input, textarea, select')) {
      dot.classList.add('hover'); ring.classList.add('hover');
    }
  });
  document.addEventListener('mouseout', function (e) {
    if (e.target.closest('a, button, [role="button"], input, textarea, select')) {
      dot.classList.remove('hover'); ring.classList.remove('hover');
    }
  });
})();

/* GLITTER */
var _glitterRunning = false, _glitterFrame, _glitterParticles = [], _glitterCanvas = null, _glitterCtx = null;
function _glitterResize() { if (!_glitterCanvas) return; _glitterCanvas.width = window.innerWidth; _glitterCanvas.height = window.innerHeight; }
function _mkParticle() {
  var type = Math.random();
  return {
    x: Math.random() * window.innerWidth, y: -10,
    size: 0.6 + Math.random() * 2.4,
    speedY: 0.4 + Math.random() * 1.2,
    speedX: -0.4 + Math.random() * 0.8,
    opacity: 0.5 + Math.random() * 0.5,
    tw: Math.random() * Math.PI * 2, twS: 0.03 + Math.random() * 0.07,
    shape: type < 0.4 ? 0 : type < 0.75 ? 1 : 2,
    rot: Math.random() * Math.PI * 2, rotS: -0.03 + Math.random() * 0.06,
    hue: Math.random() < 0.15 ? 'gold' : 'silver'
  };
}
function _drawStar(ctx, x, y, r) {
  var spikes = 4, inner = r * 0.45;
  ctx.beginPath();
  for (var s = 0; s < spikes * 2; s++) {
    var rad = s % 2 === 0 ? r : inner;
    var angle = (s * Math.PI) / spikes - Math.PI / 2;
    s === 0 ? ctx.moveTo(x + Math.cos(angle) * rad, y + Math.sin(angle) * rad)
            : ctx.lineTo(x + Math.cos(angle) * rad, y + Math.sin(angle) * rad);
  }
  ctx.closePath();
}
function startGlitter() {
  if (!_glitterCanvas) {
    _glitterCanvas = document.getElementById('glitter-canvas');
    if (!_glitterCanvas) return;
    _glitterCtx = _glitterCanvas.getContext('2d');
    window.addEventListener('resize', _glitterResize);
  }
  _glitterResize();
  if (_glitterRunning) return;
  _glitterRunning = true;
  _glitterCanvas.style.opacity = '1';
  _glitterParticles = [];
  for (var i = 0; i < 55; i++) {
    var p = _mkParticle();
    p.y = Math.random() * window.innerHeight;
    _glitterParticles.push(p);
  }
  _glitterDraw();
}
function _glitterDraw() {
  if (!_glitterRunning) return;
  var W = window.innerWidth, H = window.innerHeight;
  _glitterCtx.clearRect(0, 0, W, H);
  for (var i = 0; i < _glitterParticles.length; i++) {
    var p = _glitterParticles[i];
    p.tw += p.twS; p.rot += p.rotS; p.y += p.speedY; p.x += p.speedX;
    var a = p.opacity * (0.3 + 0.7 * Math.abs(Math.sin(p.tw)));
    var shimmer = Math.abs(Math.sin(p.tw)), r, g, b;
    if (p.hue === 'gold') { r = 220; g = 190; b = 100; }
    else { var v = Math.floor(200 + shimmer * 55); r = v; g = v; b = Math.min(255, v + 15); }
    _glitterCtx.save();
    _glitterCtx.globalAlpha = a;
    _glitterCtx.translate(p.x, p.y);
    _glitterCtx.rotate(p.rot);
    if (shimmer > 0.75) {
      _glitterCtx.shadowBlur = 6 + shimmer * 8;
      _glitterCtx.shadowColor = p.hue === 'gold' ? 'rgba(255,220,100,0.9)' : 'rgba(220,230,255,0.9)';
    } else _glitterCtx.shadowBlur = 0;
    _glitterCtx.fillStyle = 'rgb(' + r + ',' + g + ',' + b + ')';
    if (p.shape === 0) { _glitterCtx.beginPath(); _glitterCtx.arc(0, 0, p.size, 0, Math.PI * 2); _glitterCtx.fill(); }
    else if (p.shape === 1) { _drawStar(_glitterCtx, 0, 0, p.size * 1.4); _glitterCtx.fill(); }
    else { var s = p.size * 1.2; _glitterCtx.beginPath(); _glitterCtx.moveTo(0, -s); _glitterCtx.lineTo(s * 0.6, 0); _glitterCtx.lineTo(0, s); _glitterCtx.lineTo(-s * 0.6, 0); _glitterCtx.closePath(); _glitterCtx.fill(); }
    _glitterCtx.restore();
    if (p.y > H + 10) _glitterParticles[i] = _mkParticle();
  }
  _glitterFrame = requestAnimationFrame(_glitterDraw);
}

/* ═══════════════════════════════════════════
   CART — wired to Shopify Ajax API
═══════════════════════════════════════════ */
function navakFormatMoney(cents) {
  return 'AED ' + (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}
function openCart() {
  var ov = document.getElementById('cart-overlay');
  var dr = document.getElementById('cart-drawer');
  if (ov) ov.classList.add('open');
  if (dr) dr.classList.add('open');
  navakFetchCart();
}
function closeCart() {
  var ov = document.getElementById('cart-overlay');
  var dr = document.getElementById('cart-drawer');
  if (ov) ov.classList.remove('open');
  if (dr) dr.classList.remove('open');
}
function navakFetchCart() {
  return fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) { navakRenderCart(cart); return cart; });
}
function navakRenderCart(cart) {
  var body = document.getElementById('cart-items');
  var empty = document.getElementById('cart-empty');
  var footer = document.getElementById('cart-footer');
  var count = document.getElementById('cart-count');
  if (count) count.textContent = cart.item_count;
  if (!body) return;
  if (cart.item_count === 0) {
    if (empty) empty.style.display = 'flex';
    if (footer) footer.style.display = 'none';
    body.innerHTML = '';
    return;
  }
  if (empty) empty.style.display = 'none';
  if (footer) footer.style.display = 'block';
  var html = '';
  for (var i = 0; i < cart.items.length; i++) {
    var it = cart.items[i];
    var img = it.image
      ? '<img class="ci-img" src="' + it.image + '" alt="' + (it.product_title || '') + '" width="78" height="104">'
      : '<div class="ci-img" style="background:#0d1e32;width:78px;height:104px"></div>';
    var sizeLine = (it.variant_title && it.variant_title !== 'Default Title')
      ? '<div class="ci-size">SIZE: ' + it.variant_title + '</div>' : '';
    html += '<div class="cart-item" data-key="' + it.key + '">'
      + img
      + '<div class="ci-info">'
      + '<div class="ci-name">' + it.product_title + '</div>'
      + sizeLine
      + '<div class="ci-price">' + navakFormatMoney(it.line_price) + ' × ' + it.quantity + '</div>'
      + '<button class="ci-remove" type="button" onclick="navakRemoveFromCart(\'' + it.key + '\')">REMOVE</button>'
      + '</div></div>';
  }
  body.innerHTML = html;
  var totalEl = document.getElementById('cart-total-price');
  if (totalEl) totalEl.textContent = navakFormatMoney(cart.total_price);
}
function navakRemoveFromCart(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  }).then(function (r) { return r.json(); }).then(navakRenderCart);
}
/* Intercept any product-form submission → AJAX add */
document.addEventListener('submit', function (e) {
  var form = e.target;
  if (form && (form.id === 'product-form' || form.matches('form[action*="/cart/add"]'))) {
    e.preventDefault();
    var fd = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: fd
    }).then(function (r) { return r.json(); })
      .then(function () { return navakFetchCart(); })
      .then(function () { openCart(); });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var cls = document.body.className;
  if (cls.indexOf('template-collection') !== -1 || cls.indexOf('template-product') !== -1) {
    startGlitter();
  }
  // Sync cart count on load
  navakFetchCart();

  // Active nav link
  var path = location.pathname;
  document.querySelectorAll('[data-page]').forEach(function (a) {
    var key = a.getAttribute('data-page');
    if (key === 'home' && path === '/') a.classList.add('active');
    if (key === 'collections' && path.indexOf('/collections') === 0) a.classList.add('active');
    if (key === 'about' && path.indexOf('/pages/about') === 0) a.classList.add('active');
    if (key === 'contact' && path.indexOf('/pages/contact') === 0) a.classList.add('active');
  });

  // Hamburger
  var hb = document.getElementById('hamburger');
  var mn = document.getElementById('mobile-nav');
  if (hb && mn) hb.addEventListener('click', function () { mn.classList.toggle('open'); });
});
